<template>
  <div>
  <b-card no-body class="overflow-hidden" :id="this.id">
    
    <b-row no-gutters>
      <b-col  xl="4" lg="11" md="11" sm="11" xs="11" class="outer">
          <h6 class="m-0 label-titol-chart middle">{{this.index}} - {{this.titol}}</h6>
      </b-col>
      <b-col xl="1" lg="1" md="1" sm="1" xs="1"  class="outer">
        <p :id="`indicador-positiu-${this.index.replace('.','-')}`" class="middle"></p>
      </b-col>
      <b-col :id="`bar-father-${this.index.replace('.','-')}`" xl="7" lg="12" md="12" sm="12" xs="12" class="outer">
        <p :id="`bar-${this.index.replace('.','-')}`" class="middle"></p>
      </b-col>
    </b-row>
  </b-card>
  </div>
</template>

<script>
import * as d3 from "d3";
export default {
  name: "DistributionChart",
  props:{
    dades: Object,
    id: String,
    titol: String,
    index: String,
    tipus: String
  },
  data() {
    return {
      padding: 20,
      height: 35,
      indicadorRadius: 35,
      barWidth: 700,
      colors : ['#2AA901','#92D050','#FFC000','#FF0000','#C00000'],
      colors3 : ['#2AA901','#C00000','#E8E8E8'],
      colors6 : ['#E8E8E8','#2AA901','#92D050','#FFC000','#FF0000','#C00000'],
      colors11 : ['#2AA901','#92D050','#C4BD97','#FFC000','#FCD5B5','#FDEADA','#FAC090','#F79646','#E46C0A','#FF0000','#C00000']
    };
  },
  methods: {
    barX(d){
      var startWidh = 0
      var i = 0;
      while(i<d){
          startWidh = startWidh + (this.dades.opcions[i].percentatge/100)*this.barWidth;
          i++;
      }
      return startWidh;
    },
    barXWidth(d){
      return this.dades.opcions[d].percentatge*this.barWidth/100;
    },
    generateChart() {
      console.log(this.index+" - "+this.titol);
      console.log(this.tipus.includes("rang"));
      console.log(this.tipus);
      var opLength = this.dades.opcions.length;

      var svgIP = d3.select("#indicador-positiu-"+this.index.replace('.','-'));

     // console.log(d3.select("#bar-"+this.index.replace('.','')).node().getBoundingClientRect());

      this.barWidth = d3.select("#bar-"+this.index.replace('.','-')).node().getBoundingClientRect().width*0.9;

      var svg = d3.select("#bar-"+this.index.replace('.','-')).append("svg").attr("width", this.barWidth + this.padding*2).attr("height", this.indicadorRadius+this.padding*2).append("g")
          .attr("transform", "translate("+this.padding+","+this.padding+")");


      var indicadorPositiu =this.tipus.includes("rang") ? this.dades.indicadorPositiu : this.dades.indicadorPositiu.toFixed(2);

      var cIndicador = this.colors[0];
      if(indicadorPositiu>75 && indicadorPositiu<90 && !this.tipus.includes("rang")){
        cIndicador = this.colors[2];
      }
      console.log(indicadorPositiu);
      console.log(this.dades.indicadorPositiu);

      if((!this.tipus.includes("rang") && indicadorPositiu<75) || (this.tipus.includes("rang") && indicadorPositiu<8)){
        cIndicador = this.colors[4];
      }
      svgIP.style('background-color', cIndicador)
        .style('font-weight', 'bold')
        .style('color', 'black')
        .style('font-size', '125%')
        .style('text-align', 'center')
        .style("stroke-width", "1px")
        .text(indicadorPositiu+(!this.tipus.includes("rang") ? "%" : ""))
        .attr("stroke", "white");

      var i =0;

      for (i = 0; i < opLength; i++) {   
        var x = this.barX(i);
        var w = this.barXWidth(i);
        var fill = this.colors[i];
        if(opLength == 11){
          fill = this.colors11[i];
        }else if(opLength == 6){
          fill = this.colors6[i];
        }else if(opLength == 3){
          fill = this.colors3[i];
        }
        svg.append('rect')
          .attr('x', x)
          .attr('y', 0)
          .attr('width', w)
          .attr('height', this.height)
          .attr('fill', fill)
          .attr("stroke", "white")
          .style("stroke-width", "1px");
      
        var t = svg.append('text').call(text => text.append("tspan")
                          .attr("y", "0")
                          .text( this.dades.opcions[i].percentatge.toFixed(2) +"%"))
          
        var startTextX = x+(w/2)-(t.node().getComputedTextLength()/2);
        var startTextY = (this.height/2)+5;
        if(t.node().getComputedTextLength()>=w){
          if(i%2>0){
            startTextY = 0;
          }else{
            startTextY = this.height+12;
          }        
        }
        t.attr('transform', 'translate('+startTextX+','+startTextY+')');

      }
    }

  },
  mounted() {    
    this.generateChart();
  }/*,
  created() {
    window.addEventListener("resize", this.generateChart());
  },
  destroyed() {
    window.removeEventListener("resize", this.generateChart());
  }*/
};
</script>

<style>

.outer {
  display: table;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}



</style>